<template>
  <div
    v-if="null !== messages"
    class="text-sm text-red"
  >
    <p v-if="typeof messages === 'string'">
      {{ messages }}
    </p>
    <p v-else-if="1 === messages.length">
      {{ messages[0] }}
    </p>
    <ul
      v-else-if="1 < messages.length"
      class="list-disc ml-3"
    >
      <li v-for="message in messages">
        {{ message }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "adivare-form-error-block",
  props: {
    messages: {
      default: null,
      required: false,
      validator: prop => typeof prop === 'object' || typeof prop === 'string' || prop === null,
    },
  },
}
</script>
